// extracted by mini-css-extract-plugin
export default {"coin_img_name":"coinimgName_coin_img_name__MrGtz","coin_img":"coinimgName_coin_img__xJ485","coin_name":"coinimgName_coin_name__yDK4r"};